import { createAsyncThunk } from "@reduxjs/toolkit";
import { getResourceExplorerInternalPossibleGroupingsThunk } from "@/store/resource-explorer/thunks/internal/getResourceExplorerInternalPossibleGroupingsThunk";

export const initiateInternalDashboardThunk = createAsyncThunk(
  "dashboard/initiateInternalDashboard",
  async (organisationId: string, { dispatch }) => {
    dispatch(getResourceExplorerInternalPossibleGroupingsThunk(organisationId));
  },
);
